/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { InventoryImage, Button, Box, Stack, Heading } from 'sarsaparilla';
import EntryExitDateText from 'ui-permit/src/components/registration/EntryExitDateText';

export default class AlternateHolderSideDetail extends React.PureComponent {
    static propTypes = {
        acceptAlternateRequest: PropTypes.func,
        declineAlternateRequest: PropTypes.func,
        buttonsDisabled: PropTypes.bool,
        divisionName: PropTypes.string,
        entryDate: PropTypes.any,
        exitDate: PropTypes.any,
        permit: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
        }),
    };

    static defaultProps = { permit: { id: '', name: '' } };

    render() {
        return (
            <Box border="gray">
                <InventoryImage
                    type="asset"
                    hasFauxImageRatio="21:9"
                    id={this.props.permit.id}
                />
                <Stack className="p-2">
                    <Heading headingLevel={5} appearance="h5">
                        {this.props.divisionName}
                    </Heading>
                    <Heading headingLevel={6} appearance="h6">
                        {this.props.permit.name}
                    </Heading>

                    <EntryExitDateText
                        permit={this.props.permit}
                        entryDate={this.props.entryDate}
                        exitDate={this.props.exitDate}
                    />
                    <Button
                        id="accept-alternate-button"
                        shouldFitContainer
                        isDisabled={this.props.buttonsDisabled}
                        onClick={this.props.acceptAlternateRequest}
                    >
                        Accept & Send
                    </Button>
                    <Button
                        id="decline-alternate-button"
                        shouldFitContainer
                        appearance="tertiary"
                        isDisabled={this.props.buttonsDisabled}
                        onClick={this.props.declineAlternateRequest}
                    >
                        Decline Request
                    </Button>
                </Stack>
            </Box>
        );
    }
}
